module.exports = __webpack_public_path__ + "static/media/icon_caret-down.2e15136e.svg";